import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'
import { useNameInput } from './useNameInput'

interface Props {
  name: string
  showInput: boolean
  collaboratorsLength: number
  onHideInput: () => void
}

export const ProjectNameInput: React.FC<Props> = ({
  name,
  showInput,
  collaboratorsLength,
  onHideInput,
}) => {
  const { value, clickOutside, spanRef, width, handleOnChange, handleSubmit } =
    useNameInput(name, showInput, onHideInput)

  return (
    <div ref={clickOutside.ref} onClick={clickOutside.onClick}>
      <span ref={spanRef} className={css.hidden}>
        {value}
      </span>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          className={clsJoin(
            css.name_input,
            collaboratorsLength > 0 && css.with_collaborators
          )}
          value={value}
          style={{ width: `${width}px` }}
          maxLength={128}
          onChange={handleOnChange}
          onBlur={handleSubmit}
          ref={(ref) => {
            ref?.focus()
          }}
        />
      </form>
    </div>
  )
}
